
const apiConfig = {
           baseURL: "https://api.betpro777.live",
            //  baseURL: "http://localhost:5000",
};

export default apiConfig;